import { useContext } from 'react';
import Skeleton from '@mui/material/Skeleton';
import { format } from 'date-fns';
import { Helmet } from 'react-helmet-async';
import { WorkspaceFilePreviewLoadingContext } from '@/containers/Workspace.File.Preview/Context';
import { useWorkspaceFileState } from '@/containers/Workspace.File.Preview/hooks';
// import { CreatedByWhenLabel, CreatedByWhenSkeleton } from '@trinity/chat-components/components/presentation/index.js';
import { Actions } from './Header.Actions';
import { FileBreadcrumbs } from './Header.Breadcrumbs';
import styles from './style/Header.module.css';

export const Header = () => {
  const isFileLoading = useContext(WorkspaceFilePreviewLoadingContext);

  return (
    <div className={styles.root}>
      <div className={styles.wrap}>
        <div className={styles.main}>

          <FileBreadcrumbs isLoading={isFileLoading} />

          <div className={styles.details}>
            <div className={styles.info}>

              <div className={styles.header}>
                <Title />
              </div>

            </div>

            <Actions />
          </div>

          <div className={styles.subtitle}>
            {/* <CreatedBy /> */}
          </div>

        </div>
      </div>
    </div>
  );
};
/*
const CreatedBy = (props: unknown) => {
  const isLoading = useContext(WorkspaceFilePreviewLoadingContext);
  const { object } = useWorkspaceFileState();

  if (isLoading) {
    return (
      <CreatedByWhenSkeleton />
    );
  }

  return (
    <CreatedByWhenLabel
      className={styles.age}
      by={object.owner.name}
      when={`on ${format(object.createdOn, 'M/d/yyyy')}`} />
  );
};

CreatedBy.displayName = 'File.Header.CreatedBy';
*/
const Title = (props: unknown) => {
  const isLoading = useContext(WorkspaceFilePreviewLoadingContext);
  const { file, object } = useWorkspaceFileState();

  if (isLoading) {
    return (
      <Skeleton
        style={{ marginRight: 10 }}
        height={30}
        width={400}
        variant="rectangular" />
    );
  }

  // Fallback to object.name if file.name is not available
  const fileName = file?.name || object?.name || 'Untitled';

  return (
    <>
      <Helmet title={fileName} />
      <h1 className={styles.title}>{fileName}</h1>
    </>
  );
};

Title.displayName = 'File.Header.Title';